import React, { useMemo, useState } from 'react';
import { Row, Col, message, Empty, Pagination } from 'antd';
import Item from './Item';
import { gqlSchema } from '../../../gql/schema';
import {  GQL_ClassResponsePaginated } from '../../../types/class';
import * as S from './styles';
import board from '../../../assets/board.svg';
import { useQuery } from '@apollo/client';
import DashboardLoadingCard from '../../DashboardLoadingCard';
import DashboardRowStudent from '../../DashboardRowStudent';

const ClassesRow = () => {
  const [classesList, setClassesList] = useState<GQL_ClassResponsePaginated>({
    classes: [],
    totalCount: 0
  });
  
  const [currentPage, setCurrentPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const pageSize = 3;

  const { data: classData, loading, refetch } = useQuery(gqlSchema.ClassSchema.query.CLASS.CLASSES.getClassesStudentDashboard, {
    variables: { page: currentPage, limit: pageSize },
    onCompleted: ({ getClassesStudentDashboard }: { getClassesStudentDashboard?: GQL_ClassResponsePaginated }) => {
      if (getClassesStudentDashboard) {
        setClassesList({
          classes: getClassesStudentDashboard.classes || [],
          totalCount: getClassesStudentDashboard.totalCount || 0
        });
        setHasMore(getClassesStudentDashboard.classes.length === pageSize);
      } else {
        setClassesList({ classes: [], totalCount: 0 });
        setHasMore(false);
      }
    },
    
    onError: (error) => {
      message.error(
        error.message || 'There was an error loading your classes. Please try again later.',
      );
    },
  });

  const handlePageChange = (page: number) => {
    if (hasMore || page < currentPage) {
      setCurrentPage(page);
      refetch({ page, limit: pageSize });
    }
  };

  const classes = useMemo(() => {
    if (loading) {
      return (
        <Row gutter={[24, 24]}>
          {[...Array(pageSize)].map((_, index) => (
            <Col key={index} xxl={8} xl={8} lg={12} md={24} sm={24} xs={24}>
              <DashboardLoadingCard cardStyle="class" />
            </Col>
          ))}
        </Row>
      );
    }

    if (!classesList.totalCount) {
      return <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="No classes yet" />;
    }

    return (
      <Row gutter={[24, 24]}>
        {classesList.classes.map((item) => (
          <Col
            xxl={8}
            xl={8}
            lg={12}
            md={24}
            sm={24}
            xs={24}
            key={item.id}
            data-cy={`shared-studentdashboardrows-ClassRowItem-${item.id}`}
          >
            <Item classObj={item} icon={<S.LogoImage src={board} alt="Class Icon" />} />
          </Col>
        ))}
      </Row>
    );
  }, [classesList, loading]);

  const totalClasses = classData?.getClassesStudentDashboard?.totalCount || 0;

  return (
    <>
      <DashboardRowStudent title="My Classes" items={classes} extraCyTitle="student-classes" />
      <Pagination
        current={currentPage}
        pageSize={pageSize}
        total={totalClasses}
        onChange={handlePageChange}
        showSizeChanger={false}
        hideOnSinglePage={false} 
        disabled={loading}
        style={{ textAlign: 'center', marginTop: 16 }}
        showLessItems
      />
    </>
  );
};



export default ClassesRow;
